import { Component, OnInit, Input } from '@angular/core';
import { formatCurrency } from 'src/app/helpers';

@Component({
  selector: 'app-reverser-through-wallet-item',
  templateUrl: './reverser-through-wallet-item.component.html',
  styleUrls: ['./reverser-through-wallet-item.component.css']
})
export class ReverserThroughWalletItemComponent implements OnInit {

  @Input() items = [];

  constructor() { }

  ngOnInit() {
  }

  formatCurrency(currency: any) {
    return formatCurrency(currency);
  }
}
